import { TaskItemNode as SharedTaskItemNode } from '~shared/richtext/nodes/taskitem.node'

/**
 * Our customized variant of the official TaskItem extension.
 */
export const TaskItemNode = SharedTaskItemNode.extend({
  /**
   * Override `addNodeView()`, which is called by the live Tiptap editor.
   *
   * @remarks
   *   The original TaskItem extension is pure vanilla JS and is thus safe for
   *   us to override like this. If it was written in React, this could
   *   introduce sync bugs and memory leaks.
   *
   * @see https://github.com/ueberdosis/tiptap/blob/main/packages/extension-list/src/task-item/task-item.ts#L189
   */
  addNodeView() {
    return (props) => {
      const parentRenderer = this.parent?.()

      if (!parentRenderer) {
        return {
          dom: document.createElement('li'),
          contentDOM: document.createElement('span'),
        }
      }

      const result = parentRenderer(props)

      if (result && result.dom) {
        const input = result.dom.querySelector('input[type="checkbox"]')
        if (input) {
          input.setAttribute('tabindex', '-1') // Inject `tabIndex` attribute to prevent tab focus for inputs
        }
      }

      return result
    }
  },
})
